module.exports = __webpack_public_path__ + "static/img/one_number.e616134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/one_number.png
// module id = pwwG
// module chunks = 6